import { realtimeReuseMs, realtimeLifetimeMs } from "../constants/realtime";
import { signInWithCustomToken, signOut, setPersistence, inMemoryPersistence } from "firebase/auth";
import { auth } from "./firebase";
let queue = Promise.resolve();
let connected = "";
let expiresAt = 0;
let validUntil = 0;
export function connectRealtime(request, guestId = "") {
  const token = localStorage.getItem("accessToken") || "";
  const identity = guestId ? `guest:${guestId}` : token;
  const run = queue.catch(() => {}).then(async () => {
    if (!identity) throw new Error("Realtime identity missing");
    if (connected === identity && auth.currentUser && expiresAt > Date.now()) return { validUntil };
    if (connected !== identity) { await signOut(auth); connected = ""; }
    const result = await request("users-getRealtimeSession", guestId ? { guestId } : {}, { notShowLoading: true });
    if (!result?.status || !result.customToken) throw new Error("Realtime authentication failed");
    if ((localStorage.getItem("accessToken") || "") !== token) throw new Error("Session changed");
    await setPersistence(auth, inMemoryPersistence);
    await signInWithCustomToken(auth, result.customToken);
    if ((localStorage.getItem("accessToken") || "") !== token) { await signOut(auth); throw new Error("Session changed"); }
    connected = identity;
    expiresAt = Date.now() + realtimeReuseMs;
    validUntil = Date.now() + realtimeLifetimeMs - 60000;
    return { validUntil };
  });
  queue = run;
  return run;
}
export function clearRealtime() {
  connected = ""; expiresAt = 0;
  queue = queue.catch(() => {}).then(() => signOut(auth));
  return queue;
}
